import React from "react";
import { createRoot, Root } from "react-dom/client";
import App from "./App";
import "./index.css";

const roots: Record<string, Root> = {};

if (process.env.REACT_APP_IS_MF) {
  window.renderStorage = (containerId: string) => {
    const container = document.getElementById(containerId);
    if (!container) return;

    if (!roots[containerId]) {
      roots[containerId] = createRoot(container);
    }

    roots[containerId].render(<App />);
  };

  window.unmountStorage = (containerId: string) => {
    const root = roots[containerId];
    if (root) {
      root.unmount();
      delete roots[containerId];
    }
  };
} else {
  const container = document.getElementById("root");
  if (container) {
    const root = createRoot(container);
    root.render(<App />);
  }
}
